<template>
	<div class="add-breakout">
		<CircleColorBtn
			label="Add a color"
			persistent-icon="1"
			@click="openFlyout"
		>
			<template #icon>
				<svg width="24" height="24" version="1.1" viewBox="0 0 6.35 6.35" xmlns="http://www.w3.org/2000/svg">
					<path d="m1.2123 3.5936h1.5441v1.5441c0 0.23118 0.1874 0.41858 0.41858 0.41858s0.41858-0.1874 0.41858-0.41858v-1.5441h1.5441c0.23118 0 0.41858-0.1874 0.41858-0.41858s-0.1874-0.41858-0.41858-0.41858h-1.5441v-1.5441c0-0.23118-0.1874-0.41858-0.41858-0.41858s-0.41858 0.1874-0.41858 0.41858v1.5441h-1.5441c-0.23118 0-0.41858 0.1874-0.41858 0.41858s0.1874 0.41858 0.41858 0.41858z" fill="#b8b8b8" stroke-width=".0093018" />
				</svg>
			</template>
		</CircleColorBtn>
	</div>

	<ColorFlyout
		v-if="showFlyout"
		:color-data="selectableColors"
		:text="flyoutInstructions"
		@select:color="handleSelectColor"
		@close:flyout="closeFlyout"
	/>
</template>


<style lang="scss">
.add-breakout {
	$transitionSpeed: 0.125s;

	position: relative;
	flex-basis: 50%;
	display: flex;
	flex-direction: column;
	place-items: center;
	margin-bottom: 24px;
	// padding-bottom: 46px;

	@media( max-width: 1023px ) {
		padding-top: 44px;
	}

	@media( min-width: 1024px ) {
		margin-bottom: 32px;
	}
}
</style>


<script setup>
import { computed, ref } from 'vue'
import ColorFlyout from './ColorFlyout.vue'
import CircleColorBtn from './CircleColorBtn.vue'


const props = defineProps({
	selectableColors: {
		type: Array,
		required: true,
	},
	flyoutInstructions: {
		type: String,
		default: '',
	},
})


const emit = defineEmits(
	[
		'select:color',
	],
)


const showFlyout = ref( false )


/**
 * Open flyout for color selection
 *
 * @return {void}
 */
const openFlyout = () => {
	showFlyout.value = true
}


/**
 * Close flyout
 *
 * @return {void}
 */
const closeFlyout = () => {
	showFlyout.value = false
}


/**
 * Handle user selecting color from flyout
 *
 * @todo validate that color ID isn't already selected
 *
 * @param {number} colorId
 * @return {void}
 */
const handleSelectColor = colorId => {
	emit( 'select:color', colorId )

	closeFlyout()
}

</script>
